import API from '../api';

export default class TournamentSubmissionService {
  constructor() {
    this.API = new API();
  }

  archiveSubmission = (accountId, contestId) => this.API.delete(`/tournamentSubmission/${accountId}/${contestId}`);
}
